import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { addToast, ToastType } from '@/store/system';
import { useLevvelTranslation } from '@/hooks/useLevvelTranslation';

/**
 * Shows the "no internet connection" toast when the browser goes offline. Call
 * once near the app root.
 */
export const useOfflineToast = () => {
  const dispatch = useDispatch();
  const { lt } = useLevvelTranslation();
  // lt is a new function every render; read the latest one when the event
  // fires, so the listener is added once yet follows language changes.
  const ltRef = useRef(lt);
  ltRef.current = lt;

  useEffect(() => {
    // Toast on the online -> offline transition, not on navigator.onLine: it
    // can stay false while the connection works (e.g. a blocked connectivity
    // probe on Windows), and checking it per render stacked a toast per render.
    const showOfflineToast = () => {
      dispatch(
        addToast({
          msg: ltRef.current('cdb_offline_text'),
          title: (
            <div className="letter-space3">
              {ltRef.current('cdb_message_status_error_text')}
            </div>
          ) as any,
          type: ToastType.Danger,
        })
      );
    };

    window.addEventListener('offline', showOfflineToast);
    return () => window.removeEventListener('offline', showOfflineToast);
  }, [dispatch]);
};
